export default {
  rowNumber: "Row",
  to: "To",
  from: "From",
  symbol: "Symbol",
  transactionId: "Transaction ID",
  amount: "Received Amount",
  BCEQ: "Value at the Time of Receipt",
  totalBCEQ: "Total Value at the Time of Receipt",
  date: "Registration Time",
  payDate: "Payment Time",
  registerDate: "Registration Date",
  description: "For",
  giftListIsEmpty: "No gifts available",
  invited: "Invited",
  totalReward: "Total Reward Value at the Time of Receipt",
  totalTooltip1:
    "This amount indicates the total dollar value of the cryptocurrencies ",
  totalTooltip2: "at the time of receipt ",
  totalTooltip3: "and",
  totalTooltip4: " the current value",
  totalTooltip5: " of the rewards can be seen in your wallet.",
  giftsAndRemains: "Remaining Account and Festival Rewards",
  recieveReward:
    "By keeping your cryptocurrencies in your Excoino wallet and participating in various festivals, you can receive rewards.",
  guidAndRules: "Guidance and Rules for Rewards",
  todayGuidValue: "Today's Reward Value",
  rewardList: "Rewards List",
  endOfCampain: "End of Campaign"
};
